export const NAME = "userAdmin";

export const routes = {
    main: '/admin',
    anagrafiche: '/admin/anagrafiche',
    ubicazioni: '/admin/ubicazioni',
}